import React, { useState } from 'react';
import { useFetch } from '../../lib/useFetch';
import { Card, Button, Dimmer, Form, Grid, Tag, Avatar } from "tabler-react";
import PhotoModal from '../../components/modal/photoModal';
import ReactWhatsapp from 'react-whatsapp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { mapIcon } from '../../lib/helpers'

const UserViewModal = ({ recordId, closeMainModal }) => {
  const { data, loading } = useFetch(`users/${recordId}`);
  const [modalPhoto, setModalPhoto] = useState(null)

  return (
    <Card>
      {modalPhoto &&
        <PhotoModal photo={data.user.photo} close={() => setModalPhoto(null)} />
      }

      <Dimmer active={loading} loader={loading}>
        <Card.Header>
          <Card.Title>User Info</Card.Title>
          <Card.Options>
            <Button size="sm" icon="x" onClick={() => closeMainModal()} />
          </Card.Options>
        </Card.Header>
        {!loading && data &&
          <Card.Body>
            <Form onSubmit={(e) => e.preventDefault()}>
              <Form.FieldSet>
                <Grid.Row>
                  <Grid.Col>
                    <Form.Label>User Photo</Form.Label>
                    <Avatar size="md" imageURL={data.user.photo} className="mb-2 clickable"
                      onClick={() => setModalPhoto(data.user.photo)} />

                    <Form.Label>Name</Form.Label>
                    <div className="normalText">{`${data.user.firstName} ${data.user.lastName}`}</div>

                    <Form.Label>Username</Form.Label>
                    <div className="normalText">{data.user.username}</div>

                    <Form.Label>Phone Number</Form.Label>
                    {data.user.phoneNumber &&
                      <div className="normalText">
                        {data.user.phoneNumber} 
                        <ReactWhatsapp number={data.user.phoneNumber} message=""
                          element={(e) => <FontAwesomeIcon className="clickable" onClick={e.onClick} icon={mapIcon("faWhatsapp")} size='lg' color='green' />}
                        />
                      </div>
                    }
                  </Grid.Col>

                  <Grid.Col >
                    <Form.Label>Email</Form.Label>
                    <div className="normalText">{data.user.email}</div>
                  </Grid.Col>

                  <Grid.Col>
                    <Form.Label>Balance</Form.Label>
                    <div className="normalText">{data.user.balance}</div>

                    <Form.Label>Is Phone Verified</Form.Label>
                    <div className="normalText">{data.user.isPhoneVerified ? 'Yes' : 'No'}</div>

                    <Form.Label>Is Passport Verified</Form.Label>
                    <div className="normalText">{data.user.isPassportVerified ? 'Yes' : 'No'}</div>

                    <Form.Label>Is Payment Verified</Form.Label>
                    <div className="normalText">{data.user.isPaymentVerified ? 'Yes' : 'No'}</div>
                  </Grid.Col>
                </Grid.Row>

                <Form.Label>Roles</Form.Label>
                <Tag.List>
                  {data.user.roles.map(item =>
                    <Tag>{item}</Tag>
                  )}
                </Tag.List>
              </Form.FieldSet>
            </Form>
          </Card.Body>
        }
      </Dimmer>
    </Card>
  )
}

export default UserViewModal;